import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import raw from 'raw.macro';
import { useMutation, useQueryClient } from 'react-query';
import ReactMarkdown from 'react-markdown';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Table, ButtonGroup } from 'reactstrap';
import styled from 'styled-components';
import gfm from 'remark-gfm';

import { useSign, PRIVACY_MODAL, CONTROL_MODAL } from 'context/signview';
import { fetcher } from 'api/client';
import { clientContractAction } from 'api/actions/contracts';

const terms = raw('../../../markdowns/Policies/Terms.md');
const privacy = raw('../../../markdowns/Policies/Privacy.md');

const SrollContainer = styled.div`
-ms-overflow-style: none;
max-height: 240px;
overflow-y: auto;
`

function Terms({ setShow }) {

    const { t } = useTranslation();
    return (
        <>
            <ModalHeader>
                {t('sign.start_experience.terms_p6')}
            </ModalHeader>
            <ModalBody>
                <SrollContainer>
                    <ReactMarkdown source={terms} />
                </SrollContainer>
            </ModalBody>
            <ModalFooter>
                <ButtonGroup className="d-flex flex-grow-1">
                    <Button className="btn btn-sm btn-default" onClick={() => setShow('agreement')}>
                        {t('sign.privacy_policy.back')}
                    </Button>
                </ButtonGroup>
            </ModalFooter>
        </>
    )
}

function Agreement({ handleClose, setShow, ownerName }) {
    const { t } = useTranslation();
    return (<>
        <ModalHeader className="text-center">
            {t('sign.start_experience.header_title')}
        </ModalHeader>
        <ModalBody>
            <h5 className="subtitle text-center mt-2">{t('sign.start_experience.subtitle')} {ownerName}</h5>
            <p className="text-center text-muted mb-5">{t('sign.start_experience.text')}</p>

            <ul className="list-unstyled mb-5 ml-4">
                <li className="mb-2"><i className="fas fa-circle text-primary mr-2"></i>
                    <span>{t('sign.start_experience.review')}</span>
                </li>
                <li className="mb-2"><i className="fas fa-circle text-primary mr-2"></i>
                    <span>{t('sign.start_experience.select')}</span>
                    {/* <span className="font-weight-bold">{t('sign.start_experience.action')}</span> */}
                    </li>
                <li>
                    <i className="fas fa-circle text-primary mr-2"></i>
                    <span>{t('sign.start_experience.accept')}</span>
                </li>
            </ul>

            <div className="terms text-center mb-4">
                <small>{t('sign.start_experience.terms_p1')}{' '}
                    <a className="terms-btn link bold orange pointer" onClick={() => setShow('terms')}>{t('sign.start_experience.terms_p6')}</a>
                    {t('sign.start_experience.terms_p3')}
                    <span className="bold">{t('sign.start_experience.terms_p4')}</span>
                    {t('sign.start_experience.terms_p5')}{' '}
                    <a className="privacy-btn link bold orange pointer" onClick={() => setShow('privacy')}>
                        {t('sign.start_experience.terms_p2')}
                    </a>
                </small>
            </div>

        </ModalBody>
        <ModalFooter className="text-center">
            <ButtonGroup className="d-flex flex-grow-1">
                <Button id="start_experience" color="primary" onClick={handleClose}>
                    {t('sign.start_experience.start')}
                </Button>
            </ButtonGroup>
        </ModalFooter>
    </>
    )
}

function Privacy({ setShow }) {

    const { t } = useTranslation();
    return (<>
        <ModalHeader>
            {t('AVISO DE PRIVACIDAD TRATO')}
        </ModalHeader>
        <ModalBody>
            <SrollContainer>
                <ReactMarkdown source={privacy} plugins={[gfm]} escapeHtml={false} />
            </SrollContainer>
        </ModalBody>
        <ModalFooter className="text-center">
            <ButtonGroup className="d-flex flex-grow-1">
                <Button size="sm" color="secondary" onClick={() => setShow('agreement')}>
                    {t('sign.privacy_policy.back')}
                </Button>
            </ButtonGroup>
        </ModalFooter>
    </>)
}

function ModalSelector() {

    const [show, setShow] = useState('agreement');

    const queryClient = useQueryClient();

    const [{ modal, contractId, jwt, contract }, dispatch] = useSign();

    const { mutate: acceptAgreementMutation } = useMutation(() => fetcher(clientContractAction(contractId, 'acceptagreement', {}), jwt), {
        onSuccess: (data) => {
            if (data) {
                queryClient.invalidateQueries('client-contract');
                dispatch({ type: CONTROL_MODAL, close: PRIVACY_MODAL, blurMain: false })
            }
        }
    })

    const handleClose = useCallback(() => acceptAgreementMutation(), [acceptAgreementMutation]);

    return (
        <Modal isOpen={modal.includes(PRIVACY_MODAL)} centered size="md">
            {{
                'agreement': <Agreement handleClose={handleClose} setShow={setShow}></Agreement>,
                'privacy': <Privacy setShow={setShow} ownerName={`${contract?.user?.givenName || ''} ${contract?.user?.familyName || ''}`}></Privacy>,
                'terms': <Terms setShow={setShow}></Terms>
            }[show]}
        </Modal>
    )
}

export default ModalSelector;